$(document).ready(function () {
    var offset = 220;
    var duration = 500;
    $(window).scroll(function () {
        if (jQuery(this).scrollTop() > offset) {
            jQuery("#go_top_control").fadeIn(duration);
        } else {
            jQuery("#go_top_control").fadeOut(duration);
        }
    });
    $("#go_top_control").click(function (event) {
        event.preventDefault();
        jQuery("html, body").animate({
            scrollTop: 0
        }, duration);
        return false;
    });
});


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/go_top.js